import script from "./FavoriteView.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoriteView.vue?vue&type=script&setup=true&lang=js"

import "./FavoriteView.vue?vue&type=style&index=0&id=d2efa03e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2efa03e"]])

export default __exports__